let quizIsStepping = false;

document.addEventListener("change", (e) => {
	const target = e.target;
	if (!(target instanceof HTMLInputElement)) return;
	if (target.type !== "radio") return;

	const quizWrap = target.closest(".quiz-content__wrapper");
	if (!quizWrap) return;

	const fs = target.closest("fieldset");
	if (!fs || !fs.classList.contains("cf7mls_current_fs")) return;

	const allowed = ["child_class", "child_goal", "child_level"];
	if (!allowed.includes(target.name)) return;

	if (quizIsStepping) return;
	quizIsStepping = true;

	const unlock = () => {
		quizIsStepping = false;
		cleanup();
	};

	const fallbackTimer = setTimeout(unlock, 2500);

	document.addEventListener("wpcf7invalid", unlock, { once: true });
	document.addEventListener("wpcf7spam", unlock, { once: true });
	document.addEventListener("wpcf7mailfailed", unlock, { once: true });
	document.addEventListener("wpcf7mailsent", unlock, { once: true });

	const before = quizWrap.querySelector("fieldset.cf7mls_current_fs");

	const observer = new MutationObserver(() => {
		const after = quizWrap.querySelector("fieldset.cf7mls_current_fs");
		if (after && after !== before) {
			unlock();
		}
	});

	observer.observe(quizWrap, {
		subtree: true,
		attributes: true,
		attributeFilter: ["class"],
	});

	const cleanup = () => {
		clearTimeout(fallbackTimer);
		observer.disconnect();
	};

	requestAnimationFrame(() => {
		const currentFs = quizWrap.querySelector("fieldset.cf7mls_current_fs");
		const nextBtn = currentFs?.querySelector(
			".cf7mls-btns .cf7mls_next, .cf7mls_next",
		);

		if (!nextBtn) {
			unlock();
			return;
		}

		nextBtn.click();
	});
});
